var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-top"},[_c('SOFilterTitle',{attrs:{"title":"Jenis Console","id":_vm.id}}),_c('div',{staticClass:"p-l-24 p-r-24 p-d-24",attrs:{"id":_vm.id}},[_c('SOInputRadio',{attrs:{"radios":_vm.filter,"v2":true,"selected-radio":_vm.filterItem.jenisSnapConsole},on:{"selected":_vm.selected}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }